// ═══════════════════════════════════════════════════════════════════════
// data/dailyLogs.js — daily_logs table access (extracted from App.js)
// ═══════════════════════════════════════════════════════════════════════
// Thin Supabase wrappers for the daily-log CRUD. Behaviour-identical to the
// previous inline queries: each returns the raw Supabase `{ data, error }`
// result so callers keep handling errors exactly as before. The P&L payload
// (calcDaily outputs etc.) is still built by the caller. RLS is the guard.
import { supabase } from "../lib/supabaseClient";

export function insertDailyLog(payload) {
  return supabase.from("daily_logs").insert(payload).select().single();
}

// Insert-or-update by primary key — used by CSV import so re-importing an
// exported file (which carries each row's id) updates rather than duplicates.
// A payload with no `id` inserts a new row; with an `id` it updates that row.
export function upsertDailyLog(payload) {
  return supabase.from("daily_logs").upsert(payload).select().single();
}

export function deleteDailyLog(id) {
  return supabase.from("daily_logs").delete().eq("id", id);
}

export function updateDailyLog(id, payload) {
  return supabase.from("daily_logs").update(payload).eq("id", id);
}
